import { Form, InputGroup } from "react-bootstrap";

const InputField = ({
    label,
    type = "text",
    placeholder = "",
    value,
    onChange,
    name,
    required,
    readOnly,
    disabled,
    className,
    error,
    endIcon,
    maxLength,
    min,
    max,
    onKeydown,
    autoComplete = "on",
    defaultValue,
    pattern,
    as,
    rows
}) => {

    return (
        <Form.Group>

            {label && (<Form.Label> {label} </Form.Label>)}
            <InputGroup>
                <Form.Control
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    name={name}
                    as={as}
                    rows={rows}
                    required={required}
                    readOnly={readOnly}
                    disabled={disabled}
                    maxLength={maxLength}
                    min={min}
                    max={max}
                    pattern={pattern}
                    className={className}
                    onKeyDown={onKeydown}
                    autoComplete={autoComplete}
                    defaultValue={defaultValue}
                />
                {endIcon && (<InputGroup.Text className="Input-Group-Icon rounded-end">{endIcon}</InputGroup.Text>) }
            </InputGroup>
            {error && <small className="error text-danger">{error}</small>}

        </Form.Group>
    );
};

export default InputField;